import { questionTypes } from 'sharedParts';

const { questionScale, questionNumeric } = questionTypes;
export default ({ type }) =>
  [questionNumeric, questionScale].some(item => item === type);
